import { NextSeo } from 'next-seo';
import Head from 'next/head';

//screens
import { About } from '@/screens/About';

//data-helpers
import { JsonLd } from '@/datafiles/micro-data/';
import { AboutSchema } from '@/datafiles/micro-data/about';

//content
import content from '@/datafiles/about/en.json';

export default function AboutPage() {
  return (
    <>
      <Head>
        <meta name="keywords" content={content.meta.keywords} />
        {/* globals.css declares its Manrope @import after the @font-face
            rules, which browsers ignore, so Manrope is loaded here. */}
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Manrope:wght@500;600;700&display=swap"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        title={content.meta.title}
        description={content.meta.description}
        canonical="https://loadsmart.com/about/"
        openGraph={{
          url: 'https://loadsmart.com/about/',
          title: content.meta.title,
          description: content.meta.description,
        }}
        additionalMetaTags={[
          { name: 'twitter:title', content: content.meta.title },
          { name: 'twitter:description', content: content.meta.description },
        ]}
      />
      <JsonLd data={AboutSchema} />
      <About content={content} />
    </>
  );
}
